<template>
  <div>
    <PesquisaDentistaModal
        v-if="modalSelecionarDentista"
        v-model="modalSelecionarDentista"
        @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
        @confirmarDentistaSelecionado="selecionarDentista"
    />
    <v-card elevation="0">
      <v-toolbar dark color="primary" elevation="0" class="container-header-orcamento">
        <v-toolbar-title>Criar orçamento</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row wrap align-center white class="pl-5 pr-5 pt-2 align-center">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" rounded depressed color="primary" class="mr-2" @click="abrirModalSelecionarDentista">
                <v-icon>mdi-tooth</v-icon>
              </v-btn>
            </template>
            Selecionar dentista
          </v-tooltip>
          <CardDentistaSelecionadoOrcamento
              v-if="dentistaSelecionado"
              :dentista-selecionado="dentistaSelecionado"
              @removerFiltroDentista="removerFiltroDentista"
              class="mr-5"
          />
        </v-row>
        <v-row wrap align-center white class="mt-4">
          <v-col cols="12" md="12" sm="12" xs="12">
            <v-textarea
                v-model="dadosGerais.descricao"
                name="descricao"
                label="Descrição"
                placeholder="Informe a descrição"
                v-validate="{max: 500, required: true}"
                :error-messages="errors.collect('descricao')"
                counter
                filled
                auto-grow
            >
              <template v-slot:label>
                Descrição
                <span class="ml-1 red--text">*</span>
              </template>
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pa-0">
        <v-container fluid>
          <v-row wrap align-center white class="row-bottom">
            <botao-cancelar @cancelar="cancelar" text="Voltar"/>
            <div style="display: flex; flex-direction: row">
              <botao-salvar @salvar="cadastrarOrcamento"/>
            </div>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import BotaoCancelar from '@/views/components/BotaoCancelar.vue'
import BotaoSalvar from '@/views/components/BotaoSalvar.vue'
import {actionTypes} from '@/core/constants'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'
import CardDentistaSelecionadoOrcamento
from '@/views/pages/cadastros/paciente/comum/orcamento/CardDentistaSelecionadoOrcamento.vue'

export default {
    name: 'OrcamentoCadastro',
    components: {
        CardDentistaSelecionadoOrcamento, PesquisaDentistaModal, BotaoSalvar, BotaoCancelar
    },
    data() {
        return {
            idPaciente: null,
            dadosGerais: {
                pacienteId: null,
                dentistaId: null,
                descricao: null
            },
            dentistaSelecionado: null,
            modalSelecionarDentista: false,
        }
    },
    mounted() {
        this.setarIdPaciente()
    },
    methods: {
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        cancelar() {
            this.$emit('cancelarCadastro')
        },
        async cadastrarOrcamento() {
            if (await this.validarDadosFormulario()) {
                this.setarDadosGerais()
                this.setMensagemLoading('Cadastrando orçamento...')
                const resposta = await this.$store.dispatch(actionTypes.ORCAMENTO.CADASTRAR_ORCAMENTOS, this.dadosGerais)
                if (resposta) {
                    this.mostrarNotificacaoSucessoDefault()
                    const input = {...resposta, dentista: this.dentistaSelecionado}
                    this.$emit('selecionarOrcamento', input)
                }
            }
        },
        setarDadosGerais() {
            if (this.dentistaSelecionado) {
                this.dadosGerais.dentistaId = this.dentistaSelecionado.id
            }
            this.dadosGerais.pacienteId = this.idPaciente
        },
        async validarDadosFormulario() {
            return this.$validator._base.validateAll()
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        selecionarDentista(dentista) {
            this.dentistaSelecionado = dentista
            this.fecharModalSelecionarDentista()
        },
        removerFiltroDentista() {
            this.dentistaSelecionado = null
        }
    }
}
</script>


<style scoped lang="stylus">

.container-header-orcamento
  border-top-right-radius 0 !important
  border-top-left-radius 0 !important

.row-bottom
  border-top-width 1px
  border-top-style solid
  border-top-color #ccc
  box-sizing border-box
  padding 10px
  display flex
  justify-content space-between

</style>